import { render, staticRenderFns } from "./organizationSettings.vue?vue&type=template&id=268c1f50&"
import script from "./organizationSettings.vue?vue&type=script&lang=js&"
export * from "./organizationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports